import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reader-create',
  templateUrl: './reader-create.component.html',
  styleUrls: ['./reader-create.component.scss']
})
export class ReaderCreateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
